import { Box, Stack, Typography, alpha, useTheme } from "@mui/material";
import { Link } from "../../../fe-ui/atoms/Link/Link";
import { responsiveFontSizes } from "../../../fe-ui/theme/typography";
import { useTranslation } from "../../../fe-ui/hooks/use-translation";
import { ReactElement, ReactNodeArray } from "react";

type Props = {
  title: string | ReactElement | ReactNodeArray;
  description: string;
  href: string;
};

export const FeatureCard = (p: Props) => {
  const { title, href, description } = p;
  const t = useTranslation();
  const theme = useTheme();
  return (
    <Box component={Link} color="inherit" underline="none" href={href}>
      <Stack
        sx={{
          p: 3,
          height: "100%",
          backgroundColor: theme.palette.background.default,
          border: `1px solid ${theme.palette.grey[300]}`,
          borderRadius: 3,
          boxShadow: `0 0 2px 0 ${alpha("#919EAB", 0.2)}, 0 12px 24px -4px ${alpha("#919EAB", 0.12)}`,
          textAlign: "left",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            lineHeight: 24 / 20,
            fontSize: 16,
            ...responsiveFontSizes({ sm: 16, md: 18, lg: 20 }),
          }}
        >
          {title}
        </Typography>

        <Typography
          variant="body2"
          mt={4}
          sx={{
            fontWeight: 400,
            lineHeight: 24 / 16,
            fontSize: 16,
          }}
        >
          {description}
        </Typography>

        <Typography
          mt={3}
          sx={{
            fontWeight: 400,
            lineHeight: 24 / 16,
            fontSize: 16,
            color: "#15AF97",
          }}
        >
          {t("apply_index_feature_read_more")}
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="#15AF97"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              verticalAlign: "bottom",
            }}
          >
            <path d="M10.0001 18.9999C9.7664 19.0004 9.53997 18.919 9.36005 18.7699C9.15555 18.6004 9.02691 18.3564 9.00252 18.0919C8.97813 17.8274 9.06 17.564 9.23005 17.3599L13.7101 11.9999L9.39005 6.62994C9.22228 6.42335 9.14379 6.1584 9.17194 5.89376C9.20009 5.62912 9.33257 5.38662 9.54005 5.21994C9.74922 5.03591 10.0257 4.94747 10.3028 4.97594C10.58 5.00442 10.8327 5.14722 11.0001 5.36994L15.8301 11.3699C16.1334 11.7389 16.1334 12.2709 15.8301 12.6399L10.8301 18.6399C10.6266 18.8854 10.3183 19.0191 10.0001 18.9999Z" />
          </svg>
        </Typography>
      </Stack>
    </Box>
  );
};
